import React from 'react';
import styled from 'styled-components';
import { FaGithub } from 'react-icons/fa';

const HeroSection = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0;
  background: linear-gradient(135deg, var(--dark) 0%, #1a1a2e 100%);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('/game-background.jpg') no-repeat center center/cover;
    opacity: 0.2;
    z-index: 0;
  }
`;

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, transparent, var(--dark));
  z-index: 1;
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  text-transform: uppercase;
  animation: fadeIn 1s ease;

  span {
    color: var(--secondary);
    display: block;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  margin-bottom: 2.5rem;
  max-width: 800px;
  line-height: 1.8;
  color: var(--text-secondary);
  animation: fadeIn 1.2s ease;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1.5rem;
  animation: fadeIn 1.4s ease;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    max-width: 300px;
  }
`;

const PrimaryButton = styled.a`
  padding: 1rem 2.5rem;
  background: linear-gradient(90deg, var(--primary), #7e3bff);
  color: white;
  border-radius: 4px;
  font-weight: 700;
  font-family: 'Orbitron', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 4px 15px rgba(94, 23, 235, 0.3);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(94, 23, 235, 0.5);
  }
`;

const GitHubButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 2.5rem;
  background-color: #171515;
  color: white;
  border-radius: 4px;
  font-weight: 700;
  font-family: 'Orbitron', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  border: 1px solid #333;

  &:hover {
    background-color: #333;
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }
`;

const Hero = () => {
  return (
    <HeroSection>
      <HeroOverlay />
      <HeroContent>
        <Title>
          RIFT <span>Last One</span>
        </Title>
        <Subtitle>
          An AI-driven observational strategy survival game where you become a multidimensional "God". 
          Guide AI characters through revelations in an apocalyptic world, where they make their own decisions 
          based on your guidance.
        </Subtitle>
        <ButtonGroup>
          <PrimaryButton href="#about">Discover More</PrimaryButton>
          <GitHubButton href="https://github.com/lastone-games/" target="_blank" rel="noopener noreferrer">
            <FaGithub /> GitHub
          </GitHubButton>
        </ButtonGroup>
      </HeroContent>
    </HeroSection>
  );
};

export default Hero;
